import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';

const ThankYouPage = () => {
  const navigate = useNavigate();
  const WHATSAPP_NUMBER = '5561986357158';

  const buildWhatsAppMessage = (formData) => {
    let message = `Olá! Acabei de solicitar um orçamento pelo site:

*Nome:* ${formData.nome}
*WhatsApp:* ${formData.whatsapp}
*Cidade de Saída:* ${formData.cidadeSaida || 'Não informada'}
${formData.dataViagem ? `*Data:* ${formData.dataViagem}` : ''}
*Destino:* ${formData.destino}
*Adultos:* ${formData.quantidadeAdultos || 1}
*Crianças:* ${formData.quantidadeCriancas || 0}`;

    if (formData.idadesCriancas && formData.idadesCriancas.length > 0) {
      const idadesTexto = formData.idadesCriancas.map((idade, i) => `${i + 1}ª: ${idade} anos`).join(', ');
      message += `\n*Idades das crianças:* ${idadesTexto}`;
    }

    if (formData.observacoes) {
      message += `\n*Observações:* ${formData.observacoes}`;
    }

    message += `\n\nAguardo retorno!`;

    return message;
  };

  useEffect(() => {
    // Fire Google Ads conversion
    if (window.gtag) {
      window.gtag('event', 'conversion', {
        'send_to': 'AW-832544314/3bPUCMf_u7cZELq8_owD',
        'transaction_id': ''
      });
    }

    // Get form data from session
    const formDataStr = sessionStorage.getItem('formData');
    if (!formDataStr) {
      // If no form data, redirect to home
      setTimeout(() => navigate('/'), 3000);
      return;
    }

    const formData = JSON.parse(formDataStr);
    const message = buildWhatsAppMessage(formData);

    // Redirect to WhatsApp after 3 seconds
    const timer = setTimeout(() => {
      window.location.href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  const handleWhatsAppNow = () => {
    const formDataStr = sessionStorage.getItem('formData');
    if (formDataStr) {
      const formData = JSON.parse(formDataStr);
      const message = buildWhatsAppMessage(formData);
      window.location.href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 via-white to-teal-50 flex items-center justify-center px-4" data-testid="thankyou-page">
      <div className="max-w-2xl w-full text-center animate-fade-in">
        {/* Success Icon */}
        <div className="inline-flex items-center justify-center w-24 h-24 bg-green-100 rounded-full mb-8 animate-scale-in">
          <CheckCircle className="w-16 h-16 text-green-600" />
        </div>

        {/* Title */}
        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
          Obrigado! 🎉
        </h1>

        {/* Message */}
        <p className="text-xl text-gray-600 mb-8">
          Recebemos sua solicitação e já estamos preparando o melhor orçamento para você!
        </p>

        {/* Info Box */}
        <div className="bg-white rounded-2xl shadow-xl p-8 mb-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">
            O que acontece agora?
          </h2>
          <div className="space-y-4 text-left">
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                <span className="text-green-600 font-bold">1</span>
              </div>
              <p className="text-gray-700">
                Você será redirecionado para o <strong>WhatsApp</strong> em 3 segundos
              </p>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 bg-cyan-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                <span className="text-cyan-600 font-bold">2</span>
              </div>
              <p className="text-gray-700">
                Nossa equipe irá te responder com um <strong>orçamento personalizado</strong>
              </p>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 bg-orange-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                <span className="text-orange-600 font-bold">3</span>
              </div>
              <p className="text-gray-700">
                Tire suas dúvidas e <strong>reserve sua vaga</strong> com facilidade
              </p>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="space-y-4">
          <Button
            onClick={handleWhatsAppNow}
            size="lg"
            data-testid="thankyou-whatsapp-button"
            className="bg-green-600 hover:bg-green-700 text-white px-10 py-6 text-xl font-bold rounded-full shadow-2xl hover:scale-105 transition-all duration-300"
          >
            Ir para WhatsApp Agora
            <ArrowRight className="ml-2 h-6 w-6" />
          </Button>

          <p className="text-sm text-gray-500">
            Redirecionamento automático em 3 segundos...
          </p>
        </div>

        {/* Back to home */}
        <button
          onClick={() => navigate('/')}
          className="mt-8 text-gray-600 hover:text-gray-900 underline"
        >
          Voltar para o site
        </button>
      </div>
    </div>
  );
};

export default ThankYouPage;
